// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Zib","label":"styles_label__3U_rU"};